import { Link } from "react-router-dom";
import { XCircle, ArrowRight, Phone } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#f8faff] text-[#1a2332] font-body" data-testid="payment-cancel-page">
      <Seo title="Paiement annulé — DDSBillancourt" description="Votre paiement a été annulé. Aucun montant n'a été prélevé." path="/payment/cancel" noindex />
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 md:px-8 pt-32 pb-24 text-center">
        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mx-auto">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>
        <h1 className="mt-6 font-headings font-black text-3xl md:text-4xl">Paiement annulé</h1>
        <p className="mt-3 text-[#5b6577] text-lg">
          Vous avez annulé le paiement. <strong>Aucun montant n'a été prélevé</strong> sur votre carte.
        </p>
        <p className="mt-4 text-[#5b6577]">
          Vous pouvez reprendre au moment qui vous convient — nos tarifs et nos disponibilités restent identiques.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/#tarifs" data-testid="cancel-retry" className="inline-flex items-center gap-2 bg-[#00a86b] hover:bg-[#00915d] text-white font-headings font-bold rounded-xl px-6 py-3 text-sm transition-colors">
            Voir les tarifs <ArrowRight className="w-4 h-4" />
          </Link>
          <a href="tel:+33141315061" data-testid="cancel-call" className="inline-flex items-center gap-2 border-2 border-[#1a2332]/15 hover:border-[#00a86b] hover:text-[#00a86b] font-headings font-bold rounded-xl px-6 py-3 text-sm transition-colors">
            <Phone className="w-4 h-4" /> 01 41 31 50 61
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}
